<div class="loading-container" role="status" aria-live="polite" [class.redesign]="isRedesign">
  <div class="content">
    @if (isRedesign) {
      <div class="lm-spinner"></div>
    } @else if (icon === 'ring') {
      <svg viewBox="25 25 50 50" class="spinner-icon">
        <title>Loading</title>
        <circle cx="50" cy="50" fill="none" r="20" stroke-width="2" class="spinner-bg-line"></circle>
        <circle cx="50" cy="50" fill="none" r="20" stroke-miterlimit="10" stroke-width="2" class="spinner-fg-line"></circle>
      </svg>
    } @else {
      <img src="assets/cb/images/loading_box.gif" alt="">
    }
    <h1>{{content.toUpperCase()}}...</h1>
    @if (showLoadingBar) {
      <p #bodyText [class.d-none]="!hasProjectedBodyText"><ng-content></ng-content></p>
      @if (!hasProjectedBodyText) {
        <p>{{ defaultBodyText }}</p>
      }
    }
    @if (showLoadingBar && showProgressBar) {
      <div class="loading-progress-container">
        <div class="loading-progress" [ngStyle]="{ 'width': loadingProgress + '%' }"></div>
      </div>
    }
  </div>
</div>
